const state = {
    notifications: 0
};

const actions = {};

const getters = {
    notifications: state => state.notifications
};

const mutations = {
    fetch_notifications(state, documents, notifications) {
        state.notifications = notifications;
    },
    increment_notifications(state) {
        state.notifications += 1;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
